import React, {PureComponent} from 'react';
import {FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ChoiceType from '../ChoiceType';
import CommonFields from './CommonFields';
import Error from '../../../Error';

class SingleChoice3Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.optionList} />
                    </h4>
                    <FieldArray name={`${name}.choices`} component={ChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}

export default SingleChoice3Type;
